import { render } from "./forward.vue?vue&type=template&id=78471e1a&scoped=true&ts=true"
import script from "./forward.vue?vue&type=script&lang=ts"
export * from "./forward.vue?vue&type=script&lang=ts"

import "./forward.vue?vue&type=style&index=0&id=78471e1a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78471e1a"]])

export default __exports__